module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-21.a6c87117.jpg";